import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import get from 'lodash/get';

import ContentList from '../components/content-list/content-list';
import DefaultLayout from '../components/default-layout/default-layout';
import SEO from '../components/seo/seo';
import WYSIWYG from '../components/wysiwyg/wysiwyg';

const RestaurantsCitySpringsPage = ({ data }) => {

  const filters = [
    {
      title: 'Distance',
      field: 'field_distance',
      data: data.allTaxonomyTermDistance.edges,
    },
    {
      title: 'Experience',
      field: 'field_experience',
      data: data.allTaxonomyTermExperience.edges,
    },
    {
      title: 'Cuisine',
      field: 'field_cuisine',
      data: data.allTaxonomyTermCuisine.edges,
    },
  ];

  const pageNode = data.restaurantsLanding;

  return (
    <DefaultLayout data={data}>
      <SEO
        title={pageNode?.title}
        pageUrl={pageNode?.path?.alias}
        siteConfig={data.site.siteMetadata}
      />
      <ContentList
        data={get(data, 'allNodeDining.edges', [])}
        filters={filters}
        style={{ marginBottom: '95px' }}
      >
        <WYSIWYG>
          <h1 className="heading-2">{pageNode?.title}</h1>
          <div dangerouslySetInnerHTML={{ __html: pageNode?.body?.processed }} />
        </WYSIWYG>
      </ContentList>
    </DefaultLayout>

  );
};

export const query = graphql`
  query RestaurantsCitySpringsPageQuery {
  site {
    siteMetadata {
      title
      siteUrl
    }
  }

  restaurantsLanding: nodePage(
    path: { alias: { eq: "/restaurants-city-springs" } }
  ) {
    title
    path {
      alias
    }
    body {
      processed
      summary
    }
  }

  allNodeDining {
        edges {
          node {
            ... on VenueUnion {
              ... on node__dining {
                title
                drupal_id
                path {
                  alias
                }
              }
              ... on node__place {
                title
                drupal_id
                path {
                  alias
                }
              }
            }
            field_image {
              imageDerivatives {
                links {
                  max_1600_16_9 {
                    href
                  }
                  max_1600_10_7 {
                    href
                  }
                }
              }
              alt
            }
            relationships {
              field_cuisine {
                metatag {
                  attributes {
                    content
                  }
                }
                drupal_id
              }
              field_distance {
                metatag {
                  attributes {
                    content
                  }
                }
                drupal_id
              }
              field_experience {
                metatag {
                  attributes {
                    content
                  }
                }
                drupal_id
              }
              
            }
            body {
                summary
            }
          }
        }
      }
    allTaxonomyTermCuisine {
    edges {
      node {
        drupal_id
        metatag {
          attributes {
            content
            name
          }
        }
      }
    }
  }
  allTaxonomyTermDistance {
    edges {
      node {
        name
        drupal_id
      }
    }
  }
  allTaxonomyTermExperience {
    edges {
      node {
        drupal_id
        metatag {
          attributes {
            content
            name
          }
        }
      }
    }
  }
}
`;

export default RestaurantsCitySpringsPage;